.media-minimal-skin .media-time-controls {
  display: flex;
  flex: 1;
  flex-direction: row-reverse;
  gap: calc(var(--media-spacing) * 3);
  align-items: center;
  container: media-time-controls / inline-size;

  &:dir(rtl) {
    flex-direction: row;
  }
}

.media-minimal-skin .media-time-group {
  display: flex;
  gap: calc(var(--media-spacing) * 1);
  align-items: center;

  &:dir(rtl) {
    flex-direction: row-reverse;
  }
}

.media-minimal-skin .media-time {
  font-variant-numeric: tabular-nums;
}

.media-minimal-skin .media-time[role="button"] {
  cursor: pointer;
  outline: 2px solid transparent;
  outline-offset: -2px;
  border-radius: calc(var(--media-spacing) * 1);
  transition-timing-function: ease-out;
  transition-duration: 100ms;
  transition-property: outline-color, outline-offset;

  @supports (corner-shape: squircle) {
    border-radius: calc(var(--media-spacing) * 4);
    corner-shape: squircle;
  }

  &:focus-visible {
    outline-color: var(--media-focus-ring-color);
    outline-offset: 2px;
  }
}

.media-minimal-skin .media-time--current,
.media-minimal-skin .media-time-separator {
  display: none;
}

@container media-root (width > 42rem) {
  .media-minimal-skin .media-time-controls {
    flex-direction: row;

    &:dir(rtl) {
      flex-direction: row-reverse;
    }
  }

  .media-minimal-skin .media-time--duration,
  .media-minimal-skin .media-time-separator {
    color: oklch(from currentColor l c h / 0.6);
  }

  .media-minimal-skin .media-time--current,
  .media-minimal-skin .media-time-separator {
    display: inline;
  }
}
